import script from "./HeaderStudentModel.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderStudentModel.vue?vue&type=script&setup=true&lang=js"

import "./HeaderStudentModel.vue?vue&type=style&index=0&id=a5fe3a0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5fe3a0e"]])

export default __exports__